/* es5-ext/object/keys/shim */ function _(require, module, exports) {
    var isValue = require(326) /* ../is-value */;
    var keys = Object.keys;
    module.exports = function (object) {
        return keys(isValue(object) ? Object(object) : object);
    };
}
